/**
 * External dependencies
 */
import { useStaticQuery, graphql } from "gatsby"

const useHomeNews = () => {
  const { allFile: { nodes: items } } = useStaticQuery(graphql`
    query HomeNewsQuery {
      allFile(filter: {relativeDirectory: {eq: "home-news/images"}}) {
        nodes {
          relativePath
          childImageSharp {
            gatsbyImageData(layout: FULL_WIDTH)
          }
        }
      }
    }
  `)

  return items;
}

export default useHomeNews